import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'
import { NavLink } from 'reactstrap';

export default function Footer()
{
  return (
    <>
      <footer>
        <div class="head">
          <div class="container">
            <div class="row">
              <div class="col">
                <h3>Okaf</h3>
                <ul>
                  <li><NavLink tag={Link} to="hakkimizda">Hakkımızda</NavLink></li>
                  <li><NavLink tag={Link} to="kariyermerkezleriiletisim">Kariyer Merkezleri İletişim</NavLink></li>
                </ul>
              </div>
              <div class="col">
                <h3>Hızlı Linkler</h3>
                <ul>
                  <li><a href="https://www.cbiko.gov.tr/" target="_blank">CBİKO</a></li>
                  <li><a href="https://www.yetenekkapisi.org/" target="_blank">Yetenek Kapısı</a></li>
                  <li><a href="https://kariyer.samsun.edu.tr/" target="_blank">Samsun Üniversitesi Kariyer Merkezi</a></li>
                  <li><a href="https://einsan.gov.tr/" target="_blank">E-İnsan Platformu</a></li>
                  <li><a href="https://kariyerkapisi.cbiko.gov.tr/ulusalstajprogrami" target="_blank">Ulusal Staj Programı</a></li>
                  <li><a href="https://ytnk.tv/" target="_blank">ytnk.tv</a></li>
                </ul>
              </div>

              <div class="col footerIletisim">
                <div class="icons">
                  <div class="item">
                    <div class="ico"><i class="bi bi-telephone-fill"></i></div>
                    <div class="detail">
                      <span class="title">Telefon</span>
                      <span class="exp">0 (539) 349 39 55</span>
                    </div>
                  </div>
                  <div class="item">
                    <div class="ico"><i class="bi bi-envelope-fill"></i></div>
                    <div class="detail">
                      <span class="title">E-Posta Adresi</span>
                      <span class="exp">okaf@samsun.edu.tr</span>
                    </div>
                  </div>
                  <div class="item">
                    <div class="ico"><i class="bi bi-geo-alt-fill"></i></div>
                    <div class="detail">
                      <span class="title">Adres</span>
                      <span class="exp">Zafer Mah. Cumhuriyet Cd. No:33 Samsun Üniversitesi Rektörlüğü Şehir Ofisi İlkadım/SAMSUN</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="container">
            <div class="line">
              <div class="logo"><a href="https://www.samsun.edu.tr/" target='_blank'  ><img src="/assets/img/m_logo.png" alt="Samsun Üniversitesi" width="354" height="103"></img></a></div>
              <div class="copyright">Bilgi İşlem Daire Başkanlığı © 2023</div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
